function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrollDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1000 1049",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-405.602,-855.976)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,637.777,-16.2694)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-798.634,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1549.61,1099.35C1549.61,1015.46 1481.5,947.354 1397.61,947.354L1194.95,947.354C1111.06,947.354 1042.95,1015.46 1042.95,1099.35L1042.95,1566.15C1042.95,1650.04 1111.06,1718.14 1194.95,1718.14L1397.61,1718.14C1481.5,1718.14 1549.61,1650.04 1549.61,1566.15L1549.61,1099.35Z",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "33.33px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.850837,11.9841,182.046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M485.661,1065.11L485.661,1220.45",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "35.9px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.62977,-480.419,-1757.09)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,-0,-0,0.613584,248.244,1613.32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.936,659.109L266.186,752.859L172.436,659.109",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "41.67px",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.186,266.186L266.186,752.859",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "41.67px"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollDown);
export default __webpack_public_path__ + "static/media/scroll_down.a99ab5d378f7e4663f45d65e6e2f0d95.svg";
export { ForwardRef as ReactComponent };